import React from 'react';
import { CheckCircle, AlertTriangle, XCircle, Phone } from 'lucide-react';

interface CallGuidanceProps {
  isCallActive: boolean;
  wakeLockSupported: boolean;
  connectionStrength: 'strong' | 'weak' | 'disconnected';
}

const CallGuidance: React.FC<CallGuidanceProps> = ({ 
  isCallActive, 
  wakeLockSupported, 
  connectionStrength 
}) => {
  if (!isCallActive) return null;
  
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          {connectionStrength === 'strong' && (
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <CheckCircle className="h-5 w-5 text-green-600" />
            </div>
          )}
          {connectionStrength === 'weak' && (
            <AlertTriangle className="h-5 w-5 text-amber-600" />
          )}
          {connectionStrength === 'disconnected' && (
            <XCircle className="h-5 w-5 text-red-600" />
          )}
        </div>
        
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Phone className="h-4 w-4 text-blue-600" />
            <span className="font-medium text-blue-900">Call in Progress</span>
          </div>
          
          <div className="text-sm text-blue-800 space-y-1">
            {wakeLockSupported ? (
              <div className="flex items-center gap-1">
                <CheckCircle className="h-3 w-3 text-green-600" />
                <span>Screen lock disabled - your call is protected</span>
              </div>
            ) : (
              <div className="space-y-1">
                <div className="flex items-center gap-1">
                  <AlertTriangle className="h-3 w-3 text-amber-600" />
                  <span className="font-medium">Keep your screen on during the call</span>
                </div>
                <ul className="ml-4 space-y-0.5 text-xs">
                  <li>• Don't lock your phone or switch apps</li>
                  <li>• If disconnected, return here immediately</li>
                  {/iPad|iPhone|iPod/.test(navigator.userAgent) && (
                    <li>• On iOS: Consider disabling "Auto-Lock" in Settings</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallGuidance; 